/**
 * @generated SignedSource<<9c1eb339d09008aa490dc8c4d4298c13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUseCurrentArticleIdsArticle$data = {
  readonly entityId: string;
  readonly entityUuid: string;
  readonly " $fragmentType": "hooksUseCurrentArticleIdsArticle";
};
export type hooksUseCurrentArticleIdsArticle$key = {
  readonly " $data"?: hooksUseCurrentArticleIdsArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseCurrentArticleIdsArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksUseCurrentArticleIdsArticle"
};

(node as any).hash = "d4d669489bf73f1984415e63f290a8ff";

export default node;
